import axios from "axios";
import API from "../_helpers/endpointService";

export const getIADOS_ListView = (data, id) => {
  let apiUrl = API.IADOS_LISTVIEW + "?projectId=" + id + "&FromDate=" + data.FromDate + "&ToDate=" + data.ToDate + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "IADOS_LIST_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const filedeleteiados = (id, filename) => {
  let apiUrl = API.IADOS_LISTVIEW + '/photo?id=' + id + '&filename=' + filename;
  return (dispatch) => {
    axios({
      method: "DELETE",
      url: apiUrl,

    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const cfiledeleteiados = (id, filename) => {
  let apiUrl = API.IADOS_LISTVIEW + '/completionphoto?id=' + id + '&filename=' + filename;
  return (dispatch) => {
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const deletemulitiiadosdocs = (data, id, modify) => {
  let ids = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        ids += "ids=" + val.data;
      }
      else {
        ids += "&ids=" + val.data;
      }
    })
  }
  let apiUrl = API.IADOS_LISTVIEW + '/ids?' + ids + '&modify=' + modify
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "DELETE",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };

};
export const gethistorylogIADOS = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=DailyObservation'
  return (dispatch) => {
      axios({
          method: "GET",
          url: apiUrl,
          // data: data,
      })
          .then((response) => {
              if (response?.status === 200) {
                  dispatch({ type: "HISTORY_LOG", data: response.data });
              } else {
              }
          })
          .catch((error) => {
              if (error?.response?.status === 401) {
              }
          });
  };
};
export const deleteIADOS = (id,modify) => {
  let apiUrl = API.IADOS_LISTVIEW + '/' + id + '?modify=' + modify;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "delete",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};